<template>
    <v-card class="cardWrap">
        <CardTitle title="プレー時間管理" />
        <v-data-table
            :headers="headers"
            :items="desserts"
            hide-default-footer
            class="elevation-1"
            disable-pagination
            >
            <template v-slot:top>
                <v-form ref="form" lazy-validation>
                    <v-toolbar flat color="white" class="mt-1">
                        <v-col cols="2">
                            <v-select
                                class="mr-3 pt-4"
                                v-model="search.golfCourse"
                                :items="golfSelect"
                                item-value="golf_code"
                                item-text="golf_name"
                                label="ゴルフ場名"
                            />
                        </v-col>
                        <v-col cols="2">
                            <v-select
                                label="コース"
                                :items="courseSelect"
                                item-value="course_code"
                                item-text="course_name"
                                class="mr-3 pt-4"
                                v-model="search.course"
                            />
                        </v-col>
                        <v-col cols="2">
                            <!--
                            # 注意事項

                            以下の年月日の入力項目では、入力形式を YYYY-MM-DD としており、数字入力時にハイフンが自動で補完されるようになっている。
                            （keyup イベント時に formatDate 関数を呼び出しそれを行っている）

                            しかし、IMEが全角モードで数字を入力すると、上記の補完がうまく動作せず、入力した数字が二重で入ってしまう。
                            例）2021と入力すると、2021-20-21と入ってしまう。

                            この現象の回避策として、type に tel を指定することで、IMEモードがOFFになり、半角でのみ入力できるようにする。

                            なお、この年月日は手入力のみ許可するため、type に date は指定していない。
                            （date を指定するとカレンダーが表示されてしまう）
                            -->
                            <v-menu
                                ref="menu"
                                v-model="menu"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y min-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        class="mr-3 pt-4"
                                        maxlength="10"
                                        v-model="formatedDate"
                                        label="年月日"
                                        inputmode="tel"
                                        type="tel"
                                        v-on="on"
                                        @focus="focusDate(formatedDate)"
                                        @keyup.delete="deleteKeyUp($event)"
                                        @keyup="formatedDate = formatDate(formatedDate)"
                                        @keydown.tab.exact="menu = false"
                                        :rules="[
                                            rules.string_type,
                                            rules.checkDateFormat,
                                            rules.correctDate,
                                            rules.required
                                        ]"
                                    />
                                </template>
                                <v-date-picker
                                    ref="picker"
                                    v-model="formatedDate"
                                    locale="jp-ja"
                                    :day-format="date => new Date(date).getDate()"
                                    min="1900-01-01"
                                    @input="menu = false"
                                />
                            </v-menu>
                        </v-col>
                        <v-col cols="2">
                            <v-btn
                                :disabled="btn[1].isActive"
                                color="primary"
                                class="ml-5"
                                @click="clickSearch"
                            >検索</v-btn>
                        </v-col>
                        <v-col cols="2">
                            <v-btn
                                color="primary"
                                class="ml-5"
                                @click="openAddModal"
                                :disabled="addStatus || btn[2].isActive"
                            >時間追加</v-btn>
                        </v-col>
                        <v-col cols="2">
                            <v-btn
                                color="primary"
                                class="ml-5"
                                @click="openCellTimesModal"
                                :disabled="addStatus || btn[5].isActive"
                            >時間変更</v-btn>
                        </v-col>
                    </v-toolbar>
                </v-form>
            </template>
            <template v-slot:[`item.reserve_status`]="{ item }">
                {{ item.reserve_status_name }}
            </template>
            <template v-slot:[`item.detail`]="{ item }">
                <v-btn
                    :disabled="btn[3].isActive"
                    color="green darken-4"
                    small
                    text
                    @click="openChangeModal(item)">詳細</v-btn>
            </template>
            <template v-slot:[`item.delete`]="{ item }">
                <v-btn
                    :disabled="btn[4].isActive"
                    color="green darken-4"
                    small
                    text
                    @click="displayRemoveModal(item)">削除</v-btn>
            </template>
        </v-data-table>
        <v-spacer></v-spacer>
        <PlayTimeInput
            ref="Modal"
            :dialog="childDialog"
            :modeStatus="modeStatus"
            :received="passTo"
            @close="closeChild"
        />
        <CellTimes
            :golfCourses="golfSelect"
            :modal="cellTimesModal"
            :received="passTo"
            @refresh-event="closeChild"
        />
        <RemoveOverlay
            page-name="プレー時間"
            @processing="deleteCellInfo"
            @cancel="closeOverLay"
            :process-result="process"
            :OverlaySwitch="removeOverlay"
        />
    </v-card>
</template>

<script>
import CardTitle from '../../components/module/CardTitle';
import validater from '@/lib/validater';
// モーダル
import PlayTimeInput from './dialog/PlayTimeInput';
import RemoveOverlay from '@/components/overlay/RemoveOverlay';
import CellTimes from '@/views/Plan/dialog/CellTimes';

// mixins
import { authorityMixin } from '@/views/authorityMixin';
import { codeListMixin } from '@/mixins/codeList';
import { utilityMixin } from '@/mixins/utility';
import { golfCourseMixin } from '@/mixins/golfCourse';
// graphql
import {
    GET_COURSE_LIST,
    GET_PLAY_START_COLUMN,
    DELETE_CELL_INFO } from '@/constants/cell_info';

export default {
    components: {
        CardTitle,
        PlayTimeInput,
        RemoveOverlay,
        CellTimes
    },
    mixins: [
        authorityMixin,
        codeListMixin,
        utilityMixin,
        golfCourseMixin
    ],
    data () {
        return {
            removeOverlay: false,
            childDialog: false,
            cellTimesModal: false,
            addStatus: true,
            // データテーブルに渡す値
            desserts: [],
            // データテーブルの見出し要素
            headers: [
                { text: '時間', value: 'play_start', sortable: false, width: '150' },
                { text: '連携ID', value: 'plan_id', align: 'left', sortable: false, width: '150' },
                { text: '予約ステータス', align: 'center', value: 'reserve_status', sortable: false, width: '150' },
                { text: '残席数', align: 'center', value: 'player_left', sortable: false, width: '150' },
                { text: '', align: 'center', value: 'detail', sortable: false, width: '150' },
                { text: '', align: 'center', value: 'delete', sortable: false, width: '150' }
            ],
            // ゴルフグループ
            golfGroupCode: process.env.VUE_APP_GROUP_CODE,
            // ゴルフ場セレクトボックス
            golfSelect: [],
            // コースの選択ボックス
            courseSelect: [],
            // 検索値
            search: {
                golfCourse: '',
                course: '',
                playDate: ''
            },
            input: {
                cell_id: ''
            },
            // 子に渡すデータ
            modeStatus: '',
            passTo: {
                golfCourse: '',
                playDate: '',
                course: '',
                player_left: '',
                golfSelection: [
                    {
                        golf_code: ''
                    }
                ],
                courseSelect: [
                    {
                        course_name: '',
                        course_code: ''
                    }
                ]
            },
            // ログインしている者の情報
            admin: {
                user_id: '',
                user_div: '',
                golf_code: ''
            },
            process: {
                // 処理結果
                result: '',
                // 処理結果メッセージ
                resultText: '',
                // 処理中かどうか
                processing: false
            },
            // ボタンの活性・非活性
            btn: [
                { element_id: '000', element_name: '画面', isActive: true },
                { element_id: '001', element_name: '検索', isActive: true },
                { element_id: '002', element_name: '追加', isActive: true },
                { element_id: '003', element_name: '詳細', isActive: true },
                { element_id: '004', element_name: '削除', isActive: true },
                { element_id: '005', element_name: '一括枠編集', isActive: true }
            ],
            vue_id: 'SCR0029',
            rules: {
                required_golf_course: value => this.isRequired(value) || this.$t('error.validation.required.whenCardNoIs'),
                string_type: value => validater.checkDateStringType(value) || this.$t('error.validation.num'),
                checkDateFormat: value => validater.checkDateFormat(value) || this.$t('error.validation.date.Correct'),
                correctDate: value => validater.checkCorrectDate(value) || this.$t('error.validation.date.Correct'),
                required: value => validater.checkEmptyString(value) || this.$t('error.validation.required.any')
            },
            menu: false
        };
    },
    async created () {
        this.$store.commit('loading/setIsLoading', true);
        this.admin = await this.getLoginAdmin();
        this.golfSelect = await this.getGolfCourseList();
        this.search.golfCourse = this.golfSelect[0].golf_code;
        this.courseSelect = await this.getCourseList();
        this.search.course = this.courseSelect[0].course_code;
        this.search.playDate = await this.getToday();
        this.setPassTo(
            this.search.golfCourse,
            this.golfSelect,
            this.search.course,
            this.courseSelect,
            this.search.playDate);
        this.addStatus = false;
        await this.getAuthorityList();
        this.$store.commit('loading/setIsLoading', false);
        await this.getStartTime();
    },
    computed: {
        formatedDate: {
            get () {
                return this.search.playDate;
            },
            set (value) {
                value = this.addHyphen(value);
                this.search.playDate = value;
            }
        }
    },
    watch: {
        search: {
            handler (val) {
                this.addStatus = true;
                this.desserts.splice(0, this.desserts.length);
            },
            deep: true
        },
        async 'search.golfCourse' (val) {
            this.courseSelect = await this.getCourseList();
            this.search.course = this.courseSelect[0].course_code;
        }
    },
    methods: {
        /** --------------------------------------------
        * コースを取得
        *-------------------------------------------- */
        async getCourseList () {
            return this.$apollo.query({
                query: GET_COURSE_LIST,
                fetchPolicy: 'no-cache',
                variables: {
                    golf_group_code: this.golfGroupCode,
                    golf_code: this.search.golfCourse
                }
            }).then(res => {
                return res.data.GetCoursesList;
            });
        },
        /** --------------------------------------------
        * 検索処理
        * -------------------------------------------- */
        async getStartTime () {
            this.$apollo.query({
                query: GET_PLAY_START_COLUMN,
                fetchPolicy: 'no-cache',
                variables: {
                    golf_group_code: this.golfGroupCode,
                    golf_code: this.search.golfCourse,
                    course_code: this.search.course,
                    play_date: this.search.playDate
                }
            }).then(res => {
                const data = res.data.GetPlayStartColumn;
                this.desserts.splice(0, this.desserts.length);
                data.forEach(record => {
                    record['reserve_status'] = String(record['reserve_status']);
                    record['player_left'] = String(record['player_left']);
                    this.desserts.push(record);
                });
            });
        },
        /** --------------------------------------------
        * 枠情報削除処理
        * -------------------------------------------- */
        deleteCellInfo () {
            this.$store.commit('loading/setIsLoading', true);

            this.$apollo.mutate({
                mutation: DELETE_CELL_INFO,
                variables: {
                    cell_id: this.input.cell_id
                }
            }).then(res => {
                const data = res.data.deleteCellInfo.result;
                if (data === 1) {
                    this.closeOverLay();
                    this.getStartTime();
                } else if (data === 0) {
                    const resultText = '既に削除されています。';
                    throw new Error(resultText);
                }
                this.$store.commit('loading/setIsLoading', false);
            }).catch(error => {
                this.$set(this.process, 'result', 0);
                this.$set(this.process, 'resultText', error);
                this.$store.commit('loading/setIsLoading', false);
            });
        },
        /** --------------------------------------------
        * 検索ボタン処理
        * -------------------------------------------- */
        clickSearch () {
            this.setPassTo(
                this.search.golfCourse,
                this.golfSelect,
                this.search.course,
                this.courseSelect,
                this.search.playDate);
            if (this.$refs.form.validate()) {
                this.addStatus = false;
                this.getStartTime();
            }
        },
        /** --------------------------------------------
         * 子に渡すデータをセットする。
         * -------------------------------------------- */
        setPassTo (golfCourse, golfSelection, course, courseSelect, playDate) {
            this.passTo = { golfCourse, golfSelection, course, courseSelect, playDate };
        },
        /** ----------------------------------------------
         * 日付フォーマット処理
         * ---------------------------------------------- */
        deleteKeyUp (event) {
            this.search.playDate = this.formatDate(this.search.playDate);
            this.search.playDate = this.deleteKeyDelete(event);
        },
        /** --------------------------------------------
        * モーダル画面を開く
        * -------------------------------------------- */
        openAddModal () {
            this.modeStatus = 'addMode';
            this.childDialog = true;
        },
        /** --------------------------------------------
        * モーダル画面を開く
        * -------------------------------------------- */
        openChangeModal (data) {
            this.passTo.cell_id = data.cell_id;
            this.passTo.play_date = data.play_date;
            this.passTo.play_start = data.play_start;
            this.passTo.player_left = data.player_left;
            this.passTo.reserve_status = data.reserve_status;
            this.modeStatus = 'changeMode';
            this.$refs.Modal.receivedCheck();
            this.childDialog = true;
        },
        /** ----------------------------------------------
         * モーダル画面を表示する処理
         * ---------------------------------------------- */
        displayRemoveModal (data) {
            this.input.cell_id = data.cell_id;
            this.removeOverlay = true;
        },
        /** ----------------------------------------------
         * モーダル画面を閉じる処理
         * ---------------------------------------------- */
        closeOverLay () {
            this.removeOverlay = false;
            this.$set(this.input, 'cell_id', '');
            this.$set(this.process, 'result', '');
            this.$set(this.process, 'resultText', '');
        },
        /** ----------------------------------------------
         * 一括枠編集画面を開く
         * ---------------------------------------------- */
        openCellTimesModal () {
            this.cellTimesModal = true;
        },
        /** --------------------------------------------
        * 子コンポーネントを閉じる
        * -------------------------------------------- */
        closeChild () {
            this.childDialog = false;
            this.cellTimesModal = false;
            this.modeStatus = '';
            this.clickSearch();
        }
    }
};
</script>

<style>
</style>
